import amenitiesDescriptionOfSuperRoom from './hotel-super-room-amenities-description.html';
import {hubRates} from './hub-rates-enum';

export default function HotelRoomDetailsPopupController(
    roomDetails,
    cultureService,
    moment,
) {
    'ngInject';

    const vm = this;
    const SUPER_ROOM = 'SuperRoom';

    Object.assign(vm, {
        roomDetails,
        amenitiesDescriptionOfSuperRoom,
        getCurrencySign: cultureService.getCurrencySign,
        areCurrenciesTheSame,
        isVatProvided,
        isSuperRoomAmenitiesVisible,
        getHubRoomInfo,
        isHubHotelDescriptionVisible,
        moment,
    });

    function getHubRoomInfo(info) {
        const description = hubRates.find((item) => item.code === roomDetails.RoomCode);
        return description && description[info];
    }

    function isHubHotelDescriptionVisible() {
        return roomDetails
            && !!roomDetails.RoomCode;
    }
    function isSuperRoomAmenitiesVisible() {
        return roomDetails.RateDescription === SUPER_ROOM;
    }
    function areCurrenciesTheSame(cost) {
        return cost
            && cost.UserCurrencyPrice && cost.ProductCurrencyPrice
            && cost.UserCurrencyPrice.CurrencyCode === cost.ProductCurrencyPrice.CurrencyCode;
    }

    function isVatProvided() {
        return roomDetails
            && roomDetails.RoomCostDetails
            && roomDetails.RoomCostDetails.VAT
            && roomDetails.RoomCostDetails.VAT.Amount !== null;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/hotels/hotel-room/hotel-room-details/hotel-room-details-popup-controller.js